import { Checkbox } from 'design-system';
import { Eye, EyeOff } from 'lucide-react';

type LegendCheckBoxProps = {
  name: string;
  onToggle: () => void;
  visible: boolean;
};

const LegendCheckBox = ({ name, onToggle, visible }: LegendCheckBoxProps) => {
  const label = `${visible ? 'Hide' : 'Show'} ${name}`;
  const VisibilityIcon = visible ? Eye : EyeOff;

  return (
    <span
      className='inline-flex items-center gap-2'
      title={label}
    >
      <Checkbox
        aria-label={label}
        checked={visible}
        onCheckedChange={onToggle}
      />
      <VisibilityIcon
        aria-hidden='true'
        className='size-4 text-muted-foreground'
        data-legend-visibility-icon
      />
    </span>
  );
};

export default LegendCheckBox;
